import React from 'react';
import { Shield, Award, Globe, Trophy } from 'lucide-react';
import { trustBadges } from '../data/mock';

const iconMap = [
  <Shield size={18} className="text-[var(--gold-primary)]" />,
  <Award size={18} className="text-[var(--gold-primary)]" />,
  <Globe size={18} className="text-[var(--gold-primary)]" />,
  <Trophy size={18} className="text-[var(--gold-primary)]" />
];

const TrustBar = () => {
  return (
    <section className="trust-bar py-10">
      <div className="container px-4 sm:px-10">
        {/* Trust Ribbon - Centered Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-4xl mx-auto">
          {trustBadges.map((badge, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center gap-3 p-4"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[var(--bg-primary)] rounded-full border border-[var(--border-light)]">
                {iconMap[index]}
              </div>
              <span className="text-xs font-medium text-[var(--text-secondary)] leading-tight">
                {badge}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
